import React from "react";
import classNames from "classnames";
import styles from "./OptionalGroup.module.scss";
import { Button, Checkbox, useForm } from "@netapp/bxp-design-system-react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { connectors as i18nNamespace } from "../../../i18n/namespace";

export const OptionalGroupButton = ({ disabled, cancel, save }) => {
    const { t } = useTranslation(i18nNamespace);
    return <div className={classNames(styles['save-cancel'])}>
        <Button color="primary" disabled={disabled} onClick={save} className={classNames(styles['save-btn'])}>
            {t("save")}
        </Button>
        <Button color="secondary" onClick={cancel} className={classNames(styles['cancel-btn'])}>
            {t("cancel")}
        </Button>
    </div>
};

export const CheckBoxOptionalGroup = ({ closeOptionalGroup, configKey, text, selectedRow = null }) => {
    const configVar = state => selectedRow === null ? state.connectorSettings.settings : state.connectors;
    const configValue = useSelector(state => configVar(state).config?.[configKey]);
    const dispatch = useDispatch();
    const form = useForm({ formValue: configValue });
    const { formState } = form;
    const save = () => {
        const newConfig = Object.fromEntries([[configKey, formState.formValue]]);
        if (selectedRow === null) {
            dispatch({
                type: "CURRENT-CONNECTOR:UPDATE-CONFIG",
                payload: {
                    ...newConfig
                }
            });
        } else {
            dispatch({
                type: "EDIT-CONNECTOR:UPDATE-CONFIG",
                payload: {
                    ...newConfig, "agentId": selectedRow.agentId, selectedRow
                }
            });
        }
        closeOptionalGroup();
    };

    return <>
        <Checkbox className={classNames(styles['checkbox'])} form={form} name="formValue">{text}</Checkbox>
        <OptionalGroupButton disabled={(formState.formValue === configValue)} cancel={closeOptionalGroup} save={save} />
    </>
}
